<template>
	<div class="data-center">
		<kid-tabs type="card" tab-position="left" v-model="food" @tab-click="handleTab">
			<kid-tab-pane label="AI中心" :is-title="true"></kid-tab-pane>
			<kid-tab-pane label="数据运算" :is-group="true"></kid-tab-pane>
			<kid-tab-pane label="作用对接" name="actionDock">
				<router-view name="actionDock"></router-view>
			</kid-tab-pane>
			<kid-tab-pane label="餐谱设置" name="foodMenu">
				<router-view name="foodMenu"></router-view>
			</kid-tab-pane>
			<kid-tab-pane label="找平设置" name="balance">
				<router-view name="balance"></router-view>
			</kid-tab-pane>
			<kid-tab-pane label="字段控制" :is-group="true"></kid-tab-pane>
			<kid-tab-pane label="字段类别" name="dicType">
				<router-view name="dicType"></router-view>
			</kid-tab-pane>
			<kid-tab-pane label="字段管理" name="dicm">
				<router-view name="dicm"></router-view>	
			</kid-tab-pane>
		</kid-tabs>
	</div>
</template>
<script>
import {KidTabs,KidTabPane} from '@/components/KidGroupTab/index'
export default {
	components: {
		KidTabs,
		KidTabPane
	},
	data(){
		return {
			food: 'actionDock'
		}
	},
	created() {
		this.showTab();
	},
	methods:{
		handleTab(tab) {
			if(tab.name == 'actionDock') {
				this.$router.push({'path':'/aicenter/actiondock/action'})
			}
			if(tab.name == 'dicType') {
				this.$router.push({'path':'/aicenter/dicttype/typelist'})
			}
			if(tab.name == 'dicm') {
				this.$router.push({'path':'/aicenter/dicm/dictlist'})
			}
			if(tab.name == 'foodMenu') {
				this.$router.push({'path':'/aicenter/foodMenu/menuset'})
			}
			if(tab.name == 'balance') {
				this.$router.push({'path':'/aicenter/balance/adjust'})
			}
		},
		showTab() {
			const name = this.$route.meta.tab;
			this.food = name;
		}
	}
}
</script>
<style scoped>

</style>




// WEBPACK FOOTER //
// src/views/aicenter/index.vue